import { Helmet } from 'react-helmet';
import HeroContent from '/src/components/HeroContent';
import * as React from 'react';
export default {
  Helmet,
  HeroContent,
  React
};